import Toggle from "components/Input/Toggle";
import { registerInput } from "../index";

export default registerInput(Toggle);
